import {AppsGroupsData} from "@app/netscope/model/data-models";
import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  NetscopeApiService,
  Success,
  Failure,
  Response
} from "@app/services/netscope-api.service";
import {TranslocoService} from "@ngneat/transloco";
import {ClrSignpostContent, ClrTimelineLayout, ClrTimelineStepState} from "@clr/angular";
import {NetscopeUiService} from "@app/services/netscope-ui.service";
import {DuckDbServiceWithInBrowserDuckDb} from "@app/services/duck-db.service";
import {take} from "rxjs";

@Component({
    standalone: false,
  selector: 'app-netscope-diagnostic',
  templateUrl: './netscope-diagnostic.component.html',
  styleUrls: ['./netscope-diagnostic.component.css']
})
export class NetscopeDiagnosticComponent implements OnInit {

  statuses = {
    step1: ClrTimelineStepState.NOT_STARTED,
    step2: ClrTimelineStepState.NOT_STARTED,
    step3: ClrTimelineStepState.NOT_STARTED,
    step4: ClrTimelineStepState.NOT_STARTED,
    collect_status: ClrTimelineStepState.NOT_STARTED,
    operation_status: ClrTimelineStepState.NOT_STARTED,
  }
  endpointStatuses = {
    lastInfrastructure: ClrTimelineStepState.NOT_STARTED,
    dashboard: ClrTimelineStepState.NOT_STARTED,
    collectHistory: ClrTimelineStepState.NOT_STARTED,
    topology: ClrTimelineStepState.NOT_STARTED,
    flows: ClrTimelineStepState.NOT_STARTED,
    heatmap: ClrTimelineStepState.NOT_STARTED,
    appsGroups: ClrTimelineStepState.NOT_STARTED,
    externalIps: ClrTimelineStepState.NOT_STARTED,
  }
  urlDcNetscopeAgent: string;
  anonymisedUiDataPassword: string = "";
  anonymisedUiDataErrorMessage: string = undefined;
  anonymisedUiDataIsDownloading: boolean = false;
  @ViewChild("anonymisedUiDataSignpost") anonymisedUiDataSignpost: ClrSignpostContent;
  dcnetscopePasswordIsOk: boolean = false;
  vcentersAreOk: boolean = false;
  canConnectToDcnetscope: boolean = false;
  vcenters = [];
  services = [];

  constructor(private netscopeService: NetscopeApiService, public translocoService: TranslocoService, private netscopeUiService: NetscopeUiService) {
  }

  ngOnInit(): void {
    this.netscopeUiService.setViewLabel("diagnostic.name");
    this.netscopeUiService.setIconShape("checkbox-list");

    this.reloadData();
  }

  reloadData = () => {
    this.diagnoseInstallation();
  }

  initUiVariables = () => {
    this.statuses = {
      step1: ClrTimelineStepState.NOT_STARTED,
      step2: ClrTimelineStepState.NOT_STARTED,
      step3: ClrTimelineStepState.NOT_STARTED,
      step4: ClrTimelineStepState.NOT_STARTED,
      collect_status: ClrTimelineStepState.NOT_STARTED,
      operation_status: ClrTimelineStepState.NOT_STARTED,
    }
    this.urlDcNetscopeAgent = undefined;
    this.dcnetscopePasswordIsOk = false;
    this.vcentersAreOk = false;
    this.canConnectToDcnetscope = false;
    this.vcenters = [];
    this.services = [];
  }

  diagnoseInstallation = () => {

    this.initUiVariables();

    // Check the status of DC Netscope (configuration, services status)
    this.netscopeService.getNetscopeSettings().subscribe((settings) => {
      settings.filter((option) => option.option === "agent_url").map((option) => {
        this.urlDcNetscopeAgent = option.value;
        this.statuses.step1 = ClrTimelineStepState.SUCCESS;

        // Reset next steps
        this.statuses.step2 = ClrTimelineStepState.CURRENT;
        this.statuses.step3 = ClrTimelineStepState.CURRENT;
        this.statuses.step4 = ClrTimelineStepState.CURRENT;
        this.statuses.collect_status = ClrTimelineStepState.CURRENT;
        this.statuses.operation_status = ClrTimelineStepState.NOT_STARTED;

        this.netscopeService.getOverallStatus().subscribe((overallStatusReponse: Response<any>) => {

          let overallStatus;
          if (overallStatusReponse instanceof Success) {
            overallStatus = overallStatusReponse.element;
          }

          if (overallStatusReponse instanceof Failure) {
            this.statuses.step2 = ClrTimelineStepState.ERROR;
            this.statuses.step3 = ClrTimelineStepState.ERROR;
            this.canConnectToDcnetscope = false;
            return;
          }

          this.statuses.step2 = ClrTimelineStepState.SUCCESS;
          this.statuses.step3 = ClrTimelineStepState.SUCCESS;
          this.canConnectToDcnetscope = true;

          console.log(overallStatus);

          // @ts-ignore
          let lastCollectDateStr: string = overallStatus.status.last_collect;
          if (lastCollectDateStr !== undefined && lastCollectDateStr.length > 0) {
            let lastCollectDateAsEpoch = Date.parse(lastCollectDateStr);
            let nowEpoch = Math.floor(new Date().getTime() / 1000.0);

            let timeDifference = nowEpoch - lastCollectDateAsEpoch;
            if (timeDifference < 3600) {
              this.statuses.step4 = ClrTimelineStepState.SUCCESS;
              this.statuses.collect_status = ClrTimelineStepState.SUCCESS;
            }
          }

          this.netscopeService.getVcentersStatus().subscribe((
            vcentersStatusResponse: Response<any>) => {

            let vcentersStatus;
            if (
              vcentersStatusResponse instanceof Success
            ) {
              vcentersStatus = vcentersStatusResponse.element;
            }

            if (
              vcentersStatusResponse instanceof Failure
            ) {
              this.vcentersAreOk = false;
              return;
            }

            let allVcenterAreOk = true;
            let vcenters = [];
            Object.entries(vcentersStatus).map(([vcenterKey,
                                                  vcenterStatus
                                                ]) => {
              if (vcenterStatus !== "ok") {
                allVcenterAreOk = false;
              }
              vcenters.push({
                name: vcenterKey,
                status: vcenterStatus,
                cssClass: vcenterStatus === "ok" ?
                  "label-success" : "label-danger"
              });
            })

            if (allVcenterAreOk) {
              this.vcentersAreOk = true;
            }

            this.vcenters = vcenters;
            console.log(vcentersStatus);
          });

          this.netscopeService.getServicesStatus().subscribe((servicesStatusResponse: Response<any>) => {

            let servicesStatus;
            if (
              servicesStatusResponse instanceof Success
            ) {
              servicesStatus = servicesStatusResponse.element;
            }

            if (
              servicesStatusResponse instanceof Failure
            ) {
              this.statuses.operation_status = ClrTimelineStepState.ERROR;
              return;
            }

            console.log(servicesStatus);

            let allServicesAreOk = true;
            let services = [];
            services.map(([serviceKey, serviceStatus]) => {
              if (serviceStatus !== "RUNNING") {
                allServicesAreOk = false;
              }
              services.push({
                name: serviceKey,
                status: serviceStatus,
                cssClass: serviceStatus === "RUNNING" ? "label-success" : "label-danger"
              });
            })

            if (allServicesAreOk) {
              this.statuses.operation_status = ClrTimelineStepState.SUCCESS;
            }

            this.services = services;
          });
        });
      });
    });

    this.netscopeService.getLastInfrastructureVersion().subscribe((infrastructureVersionResponse: Response<any>) => {
      let infrastructureVersion;

      if (infrastructureVersionResponse instanceof Success) {
        this.endpointStatuses.lastInfrastructure = ClrTimelineStepState.SUCCESS;
        infrastructureVersion = infrastructureVersionResponse.element;
      } else {
        this.endpointStatuses.lastInfrastructure = ClrTimelineStepState.ERROR;
        this.canConnectToDcnetscope = false;
        return;
      }

      let vmsUuids = infrastructureVersion.topology.vm_only_topology.vms.map((vm) => vm.uuid);
      let hostsUuids = infrastructureVersion.topology.vm_only_topology.hosts.map((host) => host.uuid);

      // Check the status of endpoints
      this.netscopeService.getDailyTimestamps().subscribe((dailyTimeStampsDataResponse: Response<any>) => {

        if (dailyTimeStampsDataResponse instanceof Failure) {
          this.endpointStatuses.dashboard = ClrTimelineStepState.ERROR;
          this.statuses.step1 = ClrTimelineStepState.NOT_STARTED;
          this.statuses.step2 = ClrTimelineStepState.NOT_STARTED;
          this.statuses.step3 = ClrTimelineStepState.ERROR;
          this.statuses.step4 = ClrTimelineStepState.NOT_STARTED;
          this.statuses.collect_status = ClrTimelineStepState.NOT_STARTED;
          this.statuses.operation_status = ClrTimelineStepState.NOT_STARTED;
          return;
        }

        let dailyTimeStampsData;
        if (dailyTimeStampsDataResponse instanceof Success) {
          dailyTimeStampsData = dailyTimeStampsDataResponse.element;
        }

        let dailyTimestamps = dailyTimeStampsData.map((v) => v.start_time);
        let currentDayTimestamp = undefined;
        const minDay = Math.min(...dailyTimestamps);
        const maxDay = Math.max(...dailyTimestamps);
        if (currentDayTimestamp === undefined) {
          let maxTimestamp = maxDay;
          currentDayTimestamp = maxTimestamp;
        }

        // const dashboardDataObservable = this.netscopeService.getDashboardDataForFilter(vmsUuids, hostsUuids, true, currentDayTimestamp);
        // dashboardDataObservable.subscribe((dashboardDataResponse:
        //                                      Response<any>) => {
        //   if (dashboardDataResponse instanceof Success) {
        //     this.endpointStatuses.dashboard = ClrTimelineStepState.SUCCESS;
        //   }
        //   if (dashboardDataResponse instanceof Failure) {
        //     this.endpointStatuses.dashboard = ClrTimelineStepState.ERROR;
        //   }
        // });

        const dashboardGraphDataForFilterObservable = this.netscopeService
          .getDashboardGraphDataForFilter(vmsUuids, hostsUuids, true);
        dashboardGraphDataForFilterObservable.subscribe((dashboardGraphDataForFilterResponse:
                                                           Response<any>) => {
          if (
            dashboardGraphDataForFilterResponse instanceof Success
          ) {
            this.endpointStatuses.collectHistory = ClrTimelineStepState.SUCCESS;
          }
          if (
            dashboardGraphDataForFilterResponse instanceof Failure
          ) {
            this.endpointStatuses.collectHistory = ClrTimelineStepState.ERROR;
          }
        });

        // this.netscopeService.getClustersWithFilters(currentDayTimestamp, currentDayTimestamp + 1,
        //   vmsUuids, hostsUuids, true, "daily").subscribe((clustersData:
        //                                                     Response<any>) => {
        //   if (clustersData instanceof Success) {
        //     this.endpointStatuses.flows = ClrTimelineStepState.SUCCESS;
        //   }
        //   if (clustersData instanceof Failure) {
        //     this.endpointStatuses.flows = ClrTimelineStepState.ERROR;
        //   }
        // });
      });
    });


    this.netscopeService.getLastInfrastructureVersion().subscribe((lastInfrastructureVersionResponse:
                                                                     Response<any>) => {
      if (lastInfrastructureVersionResponse instanceof Failure) {
        this.endpointStatuses.topology = ClrTimelineStepState.ERROR;
      }
      if (lastInfrastructureVersionResponse instanceof Success) {
        this.endpointStatuses.topology = ClrTimelineStepState.SUCCESS;
      }
    });

    this.netscopeService.getAppsGroups("tags").subscribe((appsGroupsResponse: Response<AppsGroupsData>) => {
      if (appsGroupsResponse instanceof Success) {
        this.endpointStatuses.appsGroups = ClrTimelineStepState.SUCCESS;
      }
      if (appsGroupsResponse instanceof Failure) {
        this.endpointStatuses.appsGroups = ClrTimelineStepState.ERROR;
      }
    });

    this.netscopeService.getExternalIps().subscribe((externalIpsDataReponse: Response<any>) => {
      if (externalIpsDataReponse instanceof Success) {
        this.endpointStatuses.externalIps = ClrTimelineStepState.SUCCESS;
      }
      if (externalIpsDataReponse instanceof Failure) {
        this.endpointStatuses.externalIps = ClrTimelineStepState.ERROR;
      }
    });
  }

  openAnonymisedUiDataSignpost = () => {
    this.anonymisedUiDataPassword = "";
    this.anonymisedUiDataErrorMessage = undefined;
    this.anonymisedUiDataIsDownloading = false;
  }

  downloadAnonymisedUiData = () => {
    if (this.anonymisedUiDataPassword.length === 0) {
      this.anonymisedUiDataErrorMessage = "Please choose a password to protect the archive.";
      return;
    }

    this.anonymisedUiDataErrorMessage = undefined;
    this.anonymisedUiDataIsDownloading = true;

    this.netscopeUiService.temporalParametersSubject
      .pipe(take(1)).subscribe((value) => {
        this.netscopeService.downloadAnonymisedUiData(value, this.anonymisedUiDataPassword)
          .subscribe((response: Response<Blob>) => {
            this.anonymisedUiDataIsDownloading = false;

            if (response instanceof Failure) {
              this.anonymisedUiDataErrorMessage = "Could not generate the archive. Reload the page to refresh the displayed data, then try again.";
              return;
            }

            this.anonymisedUiDataPassword = "";
            this.anonymisedUiDataSignpost.close();
          });
    })
  }

  setLanguage = (language: "french" | "english") => {
    let languageMap: Map<string, string> = new Map([
      ["french", "fr"],
      ["english", "en"]
    ]);
    let language_code = languageMap.get(language);
    this.translocoService.setDefaultLang(language_code);
    this.translocoService.setActiveLang(language_code);
    localStorage.setItem("language", language_code);
  }
  protected readonly ClrTimelineLayout = ClrTimelineLayout;
}

